import React from 'react';
import { MainLayout } from '../components/MainLayout';
import { useApp } from '../components/AppContext';

export function PayrollInfoIntro() {
  const { navigateDirectly } = useApp();

  const handleContinue = () => {
    navigateDirectly('app-payroll-info');
  };

  return (
    <MainLayout showBack showBottomNav={false}>
      <div className="intro-screen-container">
        <div className="intro-header">
          <div className="intro-icon">
            <span className="text-4xl">💰</span>
          </div>
          <h2 className="text-2xl font-bold text-[var(--ucm-text-dark)] mb-2">
            Payroll Information
          </h2>
        </div>
        
        <div className="intro-content">
          <h3 className="text-xl font-semibold text-[var(--ucm-text-dark)] mb-6">
            Why we need this information
          </h3>
          
          <div className="intro-reasons">
            <div className="reason-item">
              <div className="reason-icon">
                <span className="text-white text-sm">💳</span>
              </div>
              <div className="reason-text">
                <strong className="block font-semibold text-[var(--ucm-text-dark)] mb-1">
                  Secure Payment
                </strong>
                <p className="text-sm text-[var(--ucm-text-medium)] leading-relaxed m-0">
                  We need your banking details to transfer your participation compensation directly to your account.
                </p>
              </div>
            </div>
            
            <div className="reason-item">
              <div className="reason-icon">
                <span className="text-white text-sm">📊</span>
              </div>
              <div className="reason-text">
                <strong className="block font-semibold text-[var(--ucm-text-dark)] mb-1">
                  Tax Compliance
                </strong>
                <p className="text-sm text-[var(--ucm-text-medium)] leading-relaxed m-0">
                  German tax law requires proper documentation for all payments to ensure legal compliance.
                </p>
              </div>
            </div>
            
            <div className="reason-item">
              <div className="reason-icon">
                <span className="text-white text-sm">⚡</span>
              </div>
              <div className="reason-text">
                <strong className="block font-semibold text-[var(--ucm-text-dark)] mb-1">
                  Fast Processing
                </strong>
                <p className="text-sm text-[var(--ucm-text-medium)] leading-relaxed m-0">
                  Complete payroll information enables us to process your payment quickly after trial completion.
                </p>
              </div>
            </div>
          </div>
          
          <div className="trust-message">
            <p className="text-sm text-[var(--ucm-dark-blue)] leading-relaxed m-0">
              <strong>Bank-level security:</strong> All financial information is encrypted and processed through secure, certified payment systems.
            </p>
          </div>
        </div>
        
        <div className="intro-actions">
          <button
            onClick={handleContinue}
            className="w-full h-14 bg-[var(--ucm-primary-teal)] text-white font-semibold rounded-full hover:bg-[var(--ucm-primary-teal-hover)] transition-colors duration-200"
          >
            Continue to Payroll Setup
          </button>
        </div>
      </div>
    </MainLayout>
  );
}